import api from './api';

// --- Client-facing ---

export const createSupportTicket = async (ticketData, token) => {
  try {
    const response = await api.post('/support/tickets', ticketData, token);
    return response.data;
  } catch (error) {
    console.error('[SupportTicketApi] Error creating ticket:', error);
    throw error;
  }
};

/**
 * Fetch a ticket's attachment (admin). Returns
 * { ticketNumber, filename, contentType, size, uploadedAt, bytes } where
 * `bytes` is base64, so the caller can render it inline with a data URI.
 *
 * Separate from getTicketDetail on purpose: an attachment can be several
 * megabytes and most tickets have none, so the list and detail views should
 * not carry that weight (ST-20260921-0002).
 */
export const getTicketAttachment = async (ticketId, token) => {
  try {
    const response = await api.get(`/support/tickets/${ticketId}/attachment`, token);
    return response.data;
  } catch (error) {
    // A ticket with no attachment is a 404 and an ordinary case, not a failure
    // worth shouting about in the console.
    if (error.response?.status === 404) return null;
    console.error('[SupportTicketApi] Error fetching attachment:', error);
    throw error;
  }
};

export const getMyTickets = async (token) => {
  try {
    const response = await api.get('/support/tickets/mine', token);
    return response.data;
  } catch (error) {
    console.error('[SupportTicketApi] Error fetching my tickets:', error);
    throw error;
  }
};

export const getTicketNotes = async (ticketId, token) => {
  try {
    const response = await api.get(`/support/tickets/${ticketId}/notes`, token);
    return response.data;
  } catch (error) {
    console.error('[SupportTicketApi] Error fetching ticket notes:', error);
    throw error;
  }
};

// --- Admin-facing ---

export const getTickets = async (filters = {}, token) => {
  try {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });
    const response = await api.get(`/support/tickets?${params.toString()}`, token);
    return response.data;
  } catch (error) {
    console.error('[SupportTicketApi] Error fetching tickets:', error);
    throw error;
  }
};

export const getTicketDetail = async (ticketId, token) => {
  try {
    const response = await api.get(`/support/tickets/${ticketId}`, token);
    return response.data;
  } catch (error) {
    console.error('[SupportTicketApi] Error fetching ticket detail:', error);
    throw error;
  }
};

export const updateTicket = async (ticketId, updates, token) => {
  try {
    const response = await api.put(`/support/tickets/${ticketId}`, updates, token);
    return response.data;
  } catch (error) {
    console.error('[SupportTicketApi] Error updating ticket:', error);
    throw error;
  }
};

export const addTicketNote = async (ticketId, noteData, token) => {
  try {
    const response = await api.post(`/support/tickets/${ticketId}/notes`, noteData, token);
    return response.data;
  } catch (error) {
    console.error('[SupportTicketApi] Error adding note:', error);
    throw error;
  }
};

export default {
  createSupportTicket,
  getMyTickets,
  getTicketNotes,
  getTickets,
  getTicketDetail,
  getTicketAttachment,
  updateTicket,
  addTicketNote
};
